<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Nom de la mise en page. Ce nom sera affiché dans les listes déroulantes de selection d'une mise en page."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="isScreenSizeAdapted" (change)="isScreenSizeAdaptedChanged($event)">
                    Adapter automatiquement la taille des colonnes à la largeur de l'écran.
                </mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="<ul><li>Si cette option est activée, les largeurs des colonnes de la liste des dossiers seront définies en % afin de permettre l'affichage de la liste sans barre de défilement horizontale.</li><li>Si cette option est désactivée, les largeurs des colonnes de la liste des dossiers seront définies en pixels. Dans le cas où la liste serait plus large que l'écran, une barre de défilement horizontale permettra de se déplacer dans la liste.</li></ul>"
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Largeur des colonnes affichant des étapes du workflow</mat-label>
                    <input matInput data-input-workflowStepColumnWidth type="number" formControlName="workflowStepColumnWidth" autocomplete="off" />
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="<ul><li>Si l'option 'Adapter automatiquement la taille des colonnes à la largeur de l'écran' n'est pas activée, ce paramètre permet de spécifier la largeur (en pixels) des colonnes affichant les étapes du workflow.</li><li>Si l'option 'Adapter automatiquement la taille des colonnes à la largeur de l'écran' est activée, ce paramètre est ignoré et la taille des colonnes affichant les étapes du workflow est calculée automatiquement.</li></ul>"
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nombre d’enregistrements par page</mat-label>
                    <input matInput data-input-workflowStepColumnWidth type="number" formControlName="recordsPerPage" autocomplete="off" />
                    @if (formGroup.get('recordsPerPage').hasError('min')) {
                        <mat-error>La valeur minimum est 50</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce paramètre permet de spécifier le nombre de dossiers affichés par défaut dans la liste des dossiers. Lorsque l'utilisateur fait défiler la liste vers le bas, le système charge un nombre de dossiers équivalent à ce paramètre jusqu'à atteindre la fin de la liste. .<br>Plus la valeur de ce paramètre est grande et moins il sera nécessaire de faire de requêtes serveur lors du défilement vertical. La contrepartie est que le temps de chargement de la liste sera plus important."
                    tooltipPosition="right"></fa-icon>
            </div>
            <div class="default-sort-form">
                @if (_context?.mode !== FormMode.Reading) {
                    <div>
                        <mat-label>Tri par défaut:</mat-label>
                    </div>
                    <div class="form-item form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Colonne utilisé pour le tri</mat-label>
                            <mat-select formControlName="sortAttributeId">
                                @for (attribute of _context.attributes; track attribute.id) {
                                    <mat-option [value]="attribute.id">
                                        {{ attribute.header }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            hubToolTip="Ce paramètre permet de définir la colonne sur laquelle le tri par défaut sera appliqué lors du chargement de la liste des dossiers."
                            tooltipPosition="right"></fa-icon>
                    </div>
                    <div class="form-item form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Sens du tri</mat-label>
                            <mat-select formControlName="sortDirection">
                                @for (sort of sorts; track sort.value) {
                                    <mat-option [value]="sort.value">
                                        {{ sort.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <fa-icon [icon]="faCircleInfo" class="info-icon" hubToolTip="Ce paramètre permet de spécifier le sens du tri par défaut." tooltipPosition="right"></fa-icon>
                    </div>
                } @else {
                    <div class="form-item form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Tri par défaut</mat-label>
                            <input matInput type="text" autocomplete="off" value="{{ defautSortValue }}" disabled="true" />
                        </mat-form-field>
                    </div>
                }
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
